export const GAP = 10;
export const MENU_MAX_HEIGHT = 280;
export const VIEWPORT_PADDING = 8;
export const PORTAL_Z_INDEX = 9999;
